var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerso2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 167,
    viewBox: "0 0 95 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0596 141.5L59.0596 87L65 90.5L72.0596 92L79 90L82.5596 86.5V144.5L77.5596 147.5H73.0596L72.0596 144.5L71.0596 104.5L69.5596 104L69.0596 106L66.5596 142L64.5596 145.5L60.0596 146L57.0596 141.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7803 63.459V68.5849L55.4403 71.6505L54.9803 65.8577L49.7803 63.459Z",
    fill: "#6E95A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4006 35.4812C58.8006 32.2763 63.1306 30.0666 65.7506 31.1217C68.3706 32.1767 72.2106 33.9385 72.2506 38.2383C72.3055 40.2316 72.232 42.2263 72.0306 44.2103L69.1506 46.0317L66.7206 42.7571L65.9106 40.6967L61.8106 41.3238L56.6006 37.8601L57.4006 35.4812Z",
    fill: "#316579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.03 152.652C41.03 160.345 52.92 166.586 67.58 166.586C82.24 166.586 94.12 160.355 94.12 152.652C94.12 147.854 89.5 143.624 82.47 141.126C82.17 141.016 82.47 143.296 82.36 143.594C82.13 144.191 81.9 145.873 80.76 145.585C80.21 145.455 80.76 146.082 78.58 146.461C77.3487 146.56 76.1113 146.56 74.88 146.461C74.48 146.391 72.24 145.256 71.88 144.092C71.5089 142.362 71.4312 140.582 71.65 138.826C70.26 138.707 68.99 138.707 67.54 138.707C67.24 138.707 67.14 141.434 66.84 141.434C66.54 141.434 66 143.425 65.74 143.425C64.7253 143.598 63.7395 143.91 62.81 144.351C62.32 144.51 60.33 145.157 59.5 144.092C58.67 143.027 56.67 143.096 57.74 139.643C47.94 141.633 41 146.709 41 152.582",
    fill: "#316579"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7807 141.802V147.306C66.7793 148.255 66.4432 149.174 65.8309 149.901C65.2187 150.629 64.3692 151.12 63.4307 151.288L52.9207 154.851C52.1265 154.995 51.3066 154.865 50.5968 154.482C49.8871 154.099 49.3302 153.486 49.0186 152.745C48.7069 152.004 48.6592 151.179 48.8833 150.407C49.1074 149.635 49.5898 148.962 50.2507 148.501L57.5507 140.389L57.9807 142.758L59.1607 143.952L60.9007 144.649L62.9007 144.41L64.9707 143.723L66.7807 141.802Z",
    fill: "#6E95A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6405 142.768C67.4805 151.457 72.0405 155.09 79.8705 155.08C87.3105 155.08 83.3205 145.525 82.4105 142.768L82.0705 144.31L80.7705 145.604L77.5305 146.749L75.2305 146.55L73.1605 145.724L72.0505 144.43L71.6405 142.768Z",
    fill: "#6E95A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7807 141.802V147.306C66.7793 148.255 66.4432 149.174 65.8309 149.902C65.2187 150.629 64.3692 151.12 63.4307 151.288L52.9207 154.851C52.1265 154.995 51.3066 154.865 50.5968 154.482C49.8871 154.099 49.3302 153.486 49.0186 152.745C48.7069 152.004 48.6592 151.179 48.8833 150.407C49.1074 149.635 49.5898 148.962 50.2507 148.501L57.4507 140.538",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4105 142.768C83.3205 145.525 87.3105 155.08 79.8705 155.08C72.0405 155.08 67.4805 151.457 71.6405 142.768",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6604 85.3467L82.4305 142.956C82.4305 147.435 71.7304 148.411 71.7304 142.956L71.3104 104.756C71.3104 104.457 71.1914 104.171 70.9795 103.96C70.7675 103.749 70.4801 103.631 70.1804 103.631C69.8807 103.631 69.5933 103.749 69.3814 103.96C69.1695 104.171 69.0504 104.457 69.0504 104.756L67.0504 140.269C67.0504 145.345 57.3504 146.739 57.4104 140.627C57.4104 140.627 58.5304 91.1395 58.8904 85.6751C61.2804 90.6219 77.0504 95.7379 82.6604 85.3467Z",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7207 61.0615V69.92L55.4407 74.8966V65.859L46.7207 61.0615Z",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4409 65.859L59.3509 62.3555L56.3509 61.0615H46.7109",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4404 74.8961L59.3504 68.5459V62.3549L60.8704 61.6582",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7803 62.7529V68.5856L55.4403 71.6512",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9209 85.6259C58.7409 83.3168 60.5509 68.8447 59.3509 68.5859L61.9009 67.2422",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6602 85.337C82.6602 83.844 81.6602 82.2514 81.6602 81.0869",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0903 56.6113C83.2003 56.8403 84.2204 58.6518 83.9904 60.7519L81.7104 81.0865C81.6315 81.8036 81.3504 82.4838 80.8994 83.0486C80.4485 83.6134 79.8462 84.0396 79.1622 84.278C78.4781 84.5164 77.7403 84.5572 77.0339 84.3958C76.3275 84.2344 75.6814 83.8773 75.1704 83.3658L64.7403 72.9845C64.0299 72.2699 63.6309 71.3055 63.6299 70.3002C63.6288 69.2949 64.0257 68.3296 64.7347 67.6135C65.4436 66.8974 66.4074 66.4882 67.4174 66.4744C68.4273 66.4607 69.402 66.8435 70.1303 67.54L74.9803 72.3276L75.8604 64.4247",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5508 61.0607V54.0934C51.5508 50.9481 53.6108 47.9721 56.7508 48.3105",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6002 68.9837L62.7002 68.0879C62.0534 67.4496 61.6563 66.6026 61.5802 65.6991L61.3802 63.2904C61.4347 62.8479 61.347 62.3996 61.1296 62.0098C60.9122 61.62 60.5764 61.3087 60.1702 61.1206L58.9802 60.5632C58.4681 60.2126 58.1163 59.6744 58.002 59.0662C57.8877 58.4581 58.0201 57.8296 58.3702 57.3185C58.4213 57.2413 58.4781 57.1681 58.5402 57.0995C58.9327 56.6531 59.4821 56.3734 60.0755 56.3178C60.6688 56.2623 61.261 56.4351 61.7302 56.8009C62.5102 57.3981 63.3902 57.9654 63.7302 58.2939C64.2402 58.8314 65.4202 59.538 65.4202 60.8618V64.8432L66.3002 66.6049",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3506 61.0615L58.4506 60.0762",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4803 49.5244L67.4803 55.2675L62.7803 51.7838",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9803 52.6396L70.0703 58.6116V67.4302",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4502 55.2686L70.0602 58.4437",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9668 56.3848C55.3497 56.1884 55.2829 55.3003 54.8174 54.4012C54.352 53.5021 53.6642 52.9324 53.2813 53.1288C52.8983 53.3252 52.9652 54.2133 53.4307 55.1124C53.8961 56.0115 54.5839 56.5812 54.9668 56.3848Z",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2207 47.8532C62.6107 47.6542 63.3007 48.2215 63.7607 49.1273C64.2207 50.033 64.2907 50.9189 63.9107 51.1179",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2803 53.1383L63.1903 47.236L66.1903 47.8033L72.0003 44.25L76.9803 47.027L78.4803 47.9427V49.5551L80.9803 52.6406V61.4393L70.1303 67.7497",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9707 56.4029L73.8007 45.2354",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8701 56.3129L62.7501 51.7842",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8701 56.1436C62.8701 55.1483 65.6101 56.6711 67.1001 59.5476C68.5901 62.4241 68.2201 65.5793 66.2701 66.5746",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4502 60.8519V63.0416L74.5602 61.3097V59.2295L71.4502 60.8519Z",
    fill: "#316579",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2806 44.2503V38.9352C72.2806 36.8656 71.4546 34.8808 69.9843 33.4174C68.514 31.954 66.5199 31.1318 64.4406 31.1318C62.3613 31.1318 60.3672 31.954 58.8969 33.4174C57.4266 34.8808 56.6006 36.8656 56.6006 38.9352V46.8083C56.6076 47.9947 56.881 49.1645 57.4006 50.2322",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M59.81 45.7633C59.81 46.1515 59.63 46.47 59.4 46.47C59.17 46.47 59 46.1515 59 45.7633C59 45.3751 59.18 45.0566 59.4 45.0566C59.62 45.0566 59.81 45.3652 59.81 45.7633Z",
    fill: "#B2C8CF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M63.81 46.7584C63.81 47.1466 63.63 47.4651 63.4 47.4651C63.17 47.4651 63 47.1466 63 46.7584C63 46.3703 63.18 46.0518 63.4 46.0518C63.62 46.0518 63.81 46.3603 63.81 46.7584Z",
    fill: "#B2C8CF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8203 37.0732C60.1803 42.7267 64.2903 41.7712 66.3803 39.9796C66.3803 41.0446 66.3103 45.1951 70.0603 45.1951",
    stroke: "#B2C8CF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4307 115.884L71.4107 114.162",
    stroke: "#B2C8CF",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerso2);
export default __webpack_public_path__ + "static/media/perso_2.877deff977ac137ebd435d3cf4093d5c.svg";
export { ForwardRef as ReactComponent };